import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  WALLET_TRANSACTION_DETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchWalletTransactionDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.WALLET_TRANSACTION_DETAILS}/${gid}`);

// eslint-disable-next-line max-len
const postApplyCashback = async ({ gid, amount }) => axiosAuthInstance.post(`${API_END_POINTS.APPLY_CASHBACK}/${gid}/redeem?amount=${amount}`);

export function* getWalletTransactionDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchWalletTransactionDetails, action.payload);
    yield put({ type: WALLET_TRANSACTION_DETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: WALLET_TRANSACTION_DETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* applyCashBack(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    const { data: { entity } } = yield call(postApplyCashback, action.payload);
    yield put({ type: WALLET_TRANSACTION_DETAILS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.WALLET.APPLY_CASHBACK,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
